module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/banner-tablet-bb2b039b6f2cc1b23a0872c57da467c3.svg";